var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPorteDocumentsVierge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.25 63H281.925C274.68 27.09 242.865 0 204.75 0H173.25C135.292 0 103.478 27.09 96.075 63H78.75C35.28 63 0 98.28 0 141.75V299.25C0 342.72 35.28 378 78.75 378H299.25C342.72 378 378 342.72 378 299.25V141.75C378 98.28 342.72 63 299.25 63ZM173.25 31.5H204.75C225.225 31.5 242.55 44.73 249.165 63H128.992C135.45 44.73 152.775 31.5 173.408 31.5H173.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorteDocumentsVierge);
export default __webpack_public_path__ + "static/media/porte-documents-vierge.dced22f92ad4f8ada013c790ee2a9b8f.svg";
export { ForwardRef as ReactComponent };